import { IIconTitleAsProps } from '../../../../../sp-types/routeDetailsType';
import { routeDetailsIcons } from '../../routeDetailsUtils';
import React from 'react';

export const InputRouteDetailsSubTitle: React.FC<IIconTitleAsProps> = ({ title, icon, update = () => {} }) => {
  return (
    <div className="flex gap-2 flex-1">
      <select
        className=" min-w-12 border"
        value={icon}
        onChange={(event) => update({ title, icon: event.target.value })}
      >
        {Object.keys(routeDetailsIcons).map(([key]) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </select>
      <input
        type="text"
        className="w-full"
        value={title}
        onChange={(event) => update && update({ title: event.target.value, icon })}
      />
    </div>
  );
};
